import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import React, { useMemo } from 'react';
import { useFetchInitialProps } from '@applyboard/ab-common';
import EducationLevelContext from "./EducationDataContext";
export var formatEducationLevelsData = function formatEducationLevelsData(educationLevelData) {
  var _Array$from;
  if (!educationLevelData || !Array.isArray(educationLevelData)) {
    return {
      families: [],
      levels: []
    };
  }
  var familiesSet = new Set(educationLevelData === null || educationLevelData === void 0 ? void 0 : educationLevelData.map(function (e) {
    return e.family;
  }));
  var families = (_Array$from = Array.from(familiesSet)) === null || _Array$from === void 0 ? void 0 : _Array$from.map(function (e) {
    return Object.freeze({
      name: e,
      id: e
    });
  });
  var levels = families === null || families === void 0 ? void 0 : families.map(function (family) {
    var _educationLevelData$f;
    return Object.freeze({
      name: family.name,
      options: educationLevelData === null || educationLevelData === void 0 ? void 0 : (_educationLevelData$f = educationLevelData.filter(function (e) {
        return e.family === family.name;
      })) === null || _educationLevelData$f === void 0 ? void 0 : _educationLevelData$f.map(function (e) {
        return Object.freeze({
          name: e.name,
          value: e.type,
          id: e.id
        });
      })
    });
  });
  return {
    families: families,
    levels: levels
  };
};
var EducationDataProvider = function EducationDataProvider(_ref) {
  var children = _ref.children;
  var _useFetchInitialProps = useFetchInitialProps('/api/grades/education_levels'),
    isLoading = _useFetchInitialProps.isLoading,
    educationLevelsData = _useFetchInitialProps.props;
  var data = useMemo(function () {
    return formatEducationLevelsData(educationLevelsData);
  }, [educationLevelsData]);
  var value = {
    data: data,
    isLoading: isLoading
  };
  return /*#__PURE__*/React.createElement(EducationLevelContext.Provider, {
    value: value
  }, children);
};
export default EducationDataProvider;